import React, { useState, ChangeEvent, useEffect } from 'react';

interface TextAreaInputProps {
    value?: string;
    onValueChange?: (value: string) => void;
    disabled?: boolean;
    rows?: number;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({ value, onValueChange, disabled, rows }) => {
    const [inputValue, setInputValue] = useState(value || '');
    
    useEffect(() => {
        setInputValue(value || '');
    }, [value]);

    const handleInputChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        setInputValue(newValue);

        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    return <textarea value={inputValue} onChange={handleInputChange} className="form-control" disabled={disabled} rows={rows}></textarea>
}

export default TextAreaInput;